import mixpanel from 'mixpanel-browser'
import { getVariantConfig, getVariantName } from './appVariant'
import { getAuthenticatedUsername } from './stores/useBootstrapStore'
import { registerAnalyticsEnvironment } from './analyticsEnvironment'

const { mixpanelToken, mixpanelOptions } = getVariantConfig().trackers
const mixpanelEnabled = Boolean(mixpanelToken)
if (mixpanelEnabled) {
    mixpanel.init(mixpanelToken, mixpanelOptions || {})
    registerAnalyticsEnvironment(mixpanel)
}
// Auto-pageview would fire before queued register() calls replay — fire it
// manually post-init so the variant super property is on it.
if (mixpanelEnabled && typeof mixpanel.track_pageview === 'function')
    mixpanel.track_pageview()

export const identifyMixpanelUser = userName => {
    try {
        if (mixpanelEnabled && userName) mixpanel.identify(userName)
    } catch (ignored) {}
}

// Person properties are how a cohort is filtered in Mixpanel funnels: a
// breakdown reads the FIRST step's event property, so a cohort split has to
// live on the profile, not on the event.
export const setAnalyticsPeopleProperty = properties => {
    try {
        if (!mixpanelEnabled) return
        const username = getAuthenticatedUsername()
        // Without an identified user, people.set writes onto a device id —
        // a junk profile that dilutes every cohort filter on this property.
        if (!username) return
        identifyMixpanelUser(username)
        mixpanel.people.set(properties)
    } catch (ignored) {}
}

// Shared-browser hygiene: without a reset on logout/switch the next account
// inherits the previous user's identity and session recordings.
export const resetAnalyticsIdentity = () => {
    try {
        if (mixpanelEnabled) mixpanel.reset()
    } catch (ignored) {}
    try {
        window.posthog?.reset?.()
    } catch (ignored) {}
}

export const sendToAnalytics = params => {
    const data = params.data || {}

    if (mixpanelEnabled) {
        // Canonical analytics identity is the username — it must match the
        // server-side sign_up_success distinct_id and the admin panel links.
        identifyMixpanelUser(getAuthenticatedUsername())
        // Stamp the app variant on every event so the two variants stay
        // distinguishable even if they ever share a Mixpanel project (today
        // they use separate tokens, so this is also a convenient filter).
        mixpanel.track(params.event, {
            ...data,
            app_variant: getVariantName(),
        })
    }

    if (params.event != 'value_action' && !data?.save_to_ai) return

    const currentContextIdArray = userFactory
        .getAllContexts()
        .filter(context =>
            context[0] ? context[0] == userFactory.getCurrentContext() : false
        )

    const currentContextId =
        currentContextIdArray &&
        currentContextIdArray[0] &&
        currentContextIdArray[0][2]
            ? currentContextIdArray[0][2]
            : ''

    const dataToSend = {
        event: params.event,
        type: data.action || data.mode || data.type || '',
        app: 'infranodus',
        source: data.source,
        mode: data.mode || '',
        contextId: currentContextId || '',
        prompt: data.data || '',
        userId: userFactory.getLoggedInUserId() || '',
    }

    socket.emit('analytics message', dataToSend)
}
